import { render } from "./ViewPositionModal.vue?vue&type=template&id=61c3cfb8&scoped=true"
import script from "./ViewPositionModal.vue?vue&type=script&lang=js"
export * from "./ViewPositionModal.vue?vue&type=script&lang=js"

import "./ViewPositionModal.vue?vue&type=style&index=0&id=61c3cfb8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c3cfb8"]])

export default __exports__